import { render, staticRenderFns } from "./GestaoAprovacaoTabela.vue?vue&type=template&id=2b0d230f&scoped=true&"
import script from "./GestaoAprovacaoTabela.vue?vue&type=script&lang=js&"
export * from "./GestaoAprovacaoTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0d230f",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/gestao-aprovacao/GestaoAprovacaoTabela.vue
// module id = 1403
// module chunks = 28